/* eslint-disable max-len -- need */
export const validateJPGiftCardAmount = (props) => {
  const { memberInfo, formSubmissionPayload } = props.dataObject;
  const { setFormSubmissionPayload, loggerApiCall } = props.functionObject;
  let isTransactionPossible = true;

  if (memberInfo?.accountTypes?.paymentType === 'Revolve'
        && Number(formSubmissionPayload.totalGiftCardAmount) > Number(formSubmissionPayload?.creditStatus?.availableCredit)) {
    // この金額ではお申し込みいただけません。カード裏面の電話番号までご連絡ください。
    loggerApiCall('status=amount exceeds available credit limit', 'info');
    isTransactionPossible = false;
    setFormSubmissionPayload({ ...formSubmissionPayload, elemId: null, totalGiftCardAmountExceedsAvailableCredit: true });
  } else if ((Number(formSubmissionPayload.totalGiftCardAmount) + Number(formSubmissionPayload?.finsTransactions?.total_transaction_amount)) > 1000000) {
    // 月間(ご入金を申し込み頂いた日から経って過去30日間)のご入金金額（累積価格及び送料の合計額）は上限50万円を超えています。今回は@~errorRemainingamount~@円までご入金申し込み頂けます。
    loggerApiCall('status=amount for the cycle exceeds 1000000 limit', 'info');
    isTransactionPossible = false;
    const errorRemainingAmount = Math.abs(1000000 - Number(formSubmissionPayload?.finsTransactions?.totalTxnAmount));
    setFormSubmissionPayload((prev) => ({
      ...prev,
      elemId: null,
      totalGiftCardAmountExceeds: false,
      totalGiftCardAmountExceedsAvailableCredit: false,
      errorRemainingAmount,
    }));
  }
  if (isTransactionPossible) {
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      elemId: 'continue',
      totalGiftCardAmountExceeds: false,
      totalGiftCardAmountExceedsAvailableCredit: false,
      errorRemainingAmount: null,
    });
  }
};
/* eslint-enable max-len -- need */
